import { render, staticRenderFns } from "./VirtualProduct.vue?vue&type=template&id=0ff7258c&scoped=true&"
import script from "./VirtualProduct.vue?vue&type=script&lang=ts&"
export * from "./VirtualProduct.vue?vue&type=script&lang=ts&"
import style0 from "./VirtualProduct.vue?vue&type=style&index=0&id=0ff7258c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff7258c",
  null
  
)

export default component.exports